module.exports = __webpack_public_path__ + "static/img/home3.91236889.png";